//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ssrReplaceAll from "~/helpers/ssrReplaceAll";

export default {
  name: 'DescriptionOfCharacteristics',

  props: {
    brand: {type: String},
    model: {type: String},
    product: {type: Object}
  },

  computed: {
    characteristics() {
      let categoriesLink = (this.product?.categories || []).map((item) => item?.slug).join("/");
      if (this.$store.state?.['local-settings']?.isJJ) {
        const slugsAdditionalCategories = (this.product?.additionalCategories || []).map((item) => item?.slug).filter((t) => !!t).join('/');
        categoriesLink = ['/catalog', slugsAdditionalCategories].join("/");
      }

      const valuePol = (this.product?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === "pol")?.values?.[0]?.slug || "";

      const characteristics = (this.product?.characteristics?.[0]?.characteristics || [])
        .filter((characteristic) => {
          return Boolean(
            characteristic.name !== "Длина заушника" &&
            characteristic.name !== "Ширина окуляра" &&
            characteristic.name !== "Высота окуляра" &&
            characteristic.name !== "Ширина переносья" &&
            characteristic.name !== "Рецепт на контактные линзы" &&
            !!characteristic.values?.[0]?.value &&
            characteristic.showInProduct
          )
        })
        .map((characteristic) => {
          const characteristicSlugs = (characteristic?.values || []).map((item) => item.slug).join(",");
          const characteristicValues = (characteristic?.values || []).map((item) => item.value).join(",");
          const isCharacteristicPol = Boolean(characteristic.slug === "pol");

          let link = '';
          if (characteristic.showInFilter) {
            link = `/${categoriesLink}/f/${characteristic?.slug}=${characteristicSlugs}`;
            if (!isCharacteristicPol && valuePol) {
              link += `/pol=${valuePol}`
            }
          }
          link = ssrReplaceAll(link, '//', '/');
          link = ssrReplaceAll(link, '///', '/');

          return {
            title: characteristic.name,
            value: characteristicValues,
            link: link,
            itemprop: characteristic.slug
          }
        })

      return characteristics
    },
    characteristic__v1() {
      let product = this?.product;
      let mainCharacteristic = {};
      const characteristics = (product?.characteristics || []).find((t) => t.name === "Основные")?.characteristics || [];

      mainCharacteristic = [...(characteristics || [])].filter((char) => {
        if (
          char.name === "Длина заушника" ||
          char.name === "Ширина окуляра" ||
          char.name === "Высота окуляра" ||
          char.name === "Ширина переносья"
        ) {
          return false
        }

        return Boolean((char?.values || []).filter((t) => t?.value !== "").length > 0)
      });

      return mainCharacteristic;
    },


  },

  methods: {

    getLinkBrand: function (characteristic) {
      const categoriesLink = (this.product?.categories || []).map((item) => item?.slug).join("/");

      return `/${categoriesLink}/f/brand=${characteristic?.slug}`
    }

  }
}
